import { render } from "./CustomerAdminShipmentTable.vue?vue&type=template&id=723e6aac&scoped=true"
import script from "./CustomerAdminShipmentTable.vue?vue&type=script&lang=js"
export * from "./CustomerAdminShipmentTable.vue?vue&type=script&lang=js"

import "./CustomerAdminShipmentTable.vue?vue&type=style&index=0&id=723e6aac&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723e6aac"]])

export default __exports__